import { createUseStyles } from 'react-jss'

export const itemTextPadding = 10
const itemTopPad = 8
const itemOffset = 0

const fg = 'var(--theme-navbar-fg)'
const bg = 'hsl(from var(--theme-navbar-fg) h s 95%)'

const itemHoverStyle = {
  cursor: 'pointer',
  color: bg,
  backgroundColor: fg
}

const itemEmphasisStyle = {
  paddingTop: itemTopPad + itemOffset,
  paddingBottom: itemTextPadding + itemOffset
}

export const style = {
  navItem: {
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'center',
    textDecoration: 'none',
    // height: '64px',
    padding: `${itemTopPad}px 10px`,
    paddingBottom: itemTextPadding,
    borderRadius: '0px',
    borderTop: '1px solid var(--theme-navbar-fg)',
    borderLeft: '1px solid var(--theme-navbar-fg)',
    backgroundColor: bg,
    color: fg,

    '&:first-child': {
      borderTopLeftRadius: '12px'
    },

    '&:last-child': {
      borderTopRightRadius: '12px',
      borderRight: '1px solid var(--theme-navbar-fg)'
    },

    '&:hover': {
      ...itemHoverStyle,
      ...itemEmphasisStyle
    },

    '&.active': {
      ...itemEmphasisStyle,
      backgroundColor: fg,
      color: bg,

      '&:hover': {
        ...itemHoverStyle
      }
    }
  }
}

export const useStyles = createUseStyles(style)
